<template>
  <div class="search-course-result">
    <search-header :searchkey.sync="searchKey">
      <div class="input-mask" @click="toSearch()"></div>
    </search-header>

    <div class="sorts">
        <div class="sort" @click="showSort = !showSort">
            {{$t('business_school.category')}}: {{courseName}}
            <svg-icon icon-class="triangle"></svg-icon>
        </div>
    </div>

    <div class="content" ref="content">
      <div class="course-content">
        <div class="no-data" v-if="!courseList.length">
          <img src="@/assets/img/nodata3.png" />
          <div class="text">
            {{$t('business_school.unfortunately_there_are_no')}}<span>「{{ searchKey }}」</span
            >{{$t('business_school.relevant_results')}}
          </div>
        </div>
        <div
          class="course-item"
          v-else
          v-for="(item, index) in courseList"
          :key="index"
        >
          <div class="courseLeft">
              <van-image  :src="$utils.setSourcePath(item.preview)">
              </van-image>
              
          </div>
          <div class="courseRight">
              <div class="title ellipsis">{{ item.title }}</div>
              <div class="tag">{{ item.typeName }}</div>
              <div class="timeBtn">
                  <span>{{ item.length }}{{$t('business_school.min')}}</span>
                  <sd-button mini2 @click.native="toPage('/learn-detail',{id: item.id})">{{$t('text.learn')}}</sd-button>
              </div>
          </div>
          <!-- <block-product :item="item"></block-product> -->
        </div>
      </div>
    </div>

    <sd-sort :list="sortData" v-if="showSort" :value="courseId" class="page-sort isTop" @choose="setSort" @cancel="showSort"></sd-sort>

  </div>
</template>

<script>

export default {
  components: { },
  name: "searchresult",
  data() {
    return {
      pageType: "",
      searchKey: "",

      showSort: false,
      courseId: "",
      sortData: [],
      courseName: this.$t('business_school.all_course'),
      courseList: [],
      orgCourseList: []
    };
  },

  watch: {
    searchKey(val) {
      if(val){
        console.log("searchKey is empty", val);
        
        this.getData();
      }
    }
  },

  computed: {},

  beforeMount() {
    
    let query = this.$route.query;
    if (query.key) {
      this.searchKey = query.key;
      console.log("beforeMount searchKey", this.searchKey);
    }
  },

  mounted() {
    this.getFilter();
  },

  methods: {
    
    setSort(item) {
        this.courseId = item.key;
        this.courseName = item.name
        this.showSort  = false
        this.courseList = this.orgCourseList.filter(course => {
            return this.courseId ? course.typeName === this.courseName : course.typeName ;
        });
    },
    async getFilter() {
        let res = await this.$apis.school.getCourseTypeList()
        this.sortData = [{key:'',name:this.$t('business_school.all_course')},...res.data.list.map(item=>({key:item.id,name:item.typeName}))]
        
    },
    getData() {
      this.$apis.school.getCourseList({searchTxt: this.searchKey}).then(res => {
        if (res.code === 200) {
          this.orgCourseList = res.data.list;
          this.courseList = res.data.list;
          console.log(this.courseList);
          
        } else {
          this.$utils.message(this, res.data.msg);
        }
      });
    },
    toSearch() {
      let query = this.$route.query;
      this.toPage("/search-case", query);
    },

    toCaseDetail(item) {
      this.toPage("./cases-detail", { id: item.id });
    },

    toPage(path, query) {
      this.$router.push({
        path,
        query
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-course-result {
  height: 100%;
  display: flex;
  flex-direction: column;

  .search-header {
    position: relative;

    .input-mask {
      position: absolute;
      width: 288px;
      height: 36px;
    }
    /deep/ .input {
      flex: 1;
    }
    /deep/ .project-input {
      width: 100%;
    }
  }


  .content {
    flex: 1;
    overflow: auto;
    background-color: #f4f5f8;

    .no-data {
      height: fit-content;
      margin: auto;
      margin-top: 100px;

      img {
        width: 188px;
        height: 186px;
        margin-bottom: 23px;
      }
      .text {
        color: #aeb2b8;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 16px;

        span {
          color: #e22f25;
        }
      }

      .buttons {
        width: 335px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .button {
          font-size: 14px;
          line-height: 16px;
          padding: 8px 12px;
          border-radius: 4px;
          background-color: white;
          margin-right: 12px;
          margin-bottom: 12px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .Ablock {
      background-color: white;
      margin-bottom: 12px;
      padding: 0 20px;

      .title {
        font-size: 20px;
        line-height: 24px;
        padding: 24px 0 12px;
        text-align: left;
      }

      .block-content {
        width: 100%;
        display: flex;

        .item {
          margin-bottom: 24px;

          .img {
            border-radius: 4px;
            overflow: hidden;
          }
        }

        &.collections {
          flex-wrap: wrap;
          justify-content: space-between;

          .item {
            width: 105px;
          }

          .img {
            width: 105px;
            height: 105px;
            position: relative;

            .tag {
              position: absolute;
              font-size: 14px;
              line-height: 20px;
              color: #636872;
              padding: 0 4px;
              background-color: #e6e7ea;
              top: 4px;
              right: 4px;
              border-radius: 2px;
            }
          }

          .name {
            font-size: 13px;
            line-height: 15px;
            margin-top: 8px;
          }
        }

        &.case {
          overflow: auto;
          text-align: left;

          .item {
            flex-shrink: 0;
            width: 290px;
            margin-right: 13px;

            .img {
              width: 100%;
              height: 175px;
            }

            .name {
              font-size: 14px;
              color: #333333;
              line-height: 16px;
              margin: 8px 0 2px;
              font-weight: bold;
            }

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #7e7f85;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        height: 48px;

        .arrow {
          transform: rotate(270deg);
          margin-left: 2px;
          color: #7e7f85;
          width: 16px;
        }
      }
    }
  }

  .course-content {
    // height: calc(100% - 24px);
    overflow: auto;
    padding: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .course-item {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      padding: 10px;
      border-radius: 5px;
      background: #fff;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
      .courseLeft{
          .van-image{
              width: 150px;
              height: 100px;
              span{
                  background: rgba(0,0,0,.4);
                  padding: 2px;
                  color: #fff;
                  border-radius: 4px;
                  position: absolute;
                  bottom: 0;
                  min-width: 40px;
                  left: 2px;
                  font-weight: normal;
              }
          }
      }
      .courseRight{
          width: calc(100% - 150px);
          .title{
              text-align: left;
              text-indent: 5px;
          }
          .tag{
              display: inline-block;
              padding: 4px;
              border-radius: 4px;
              color: #636872;
              background: #e6e7ea;
              float: left;
              margin-left: 10px;
          }
          .timeBtn{
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 10px;
              box-sizing: border-box;
              .main-block{
                  width: 80px;
                  height: 30px;
              }
          }
      }

    }
  }

}
.sorts {
    padding: 11px 16px;
    background-color: white;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.0500);
    box-sizing: border-box;

    .sort {
        font-size: 14px;
        line-height: 22px;
        position: relative;
        color: #484C54;

        &.active {
            color: #E22F25;

            .triangle {
                font-size: 14px;
                color: #E22F25;
                transform: rotate(180deg);
            }
        }

        .triangle {
            height: 22px;
            position: relative;
            display: inline;
            top: 1px;
        }
    }

    .type {
        flex: 1;
        text-align: left;
        margin-left: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/result.vue